module.exports = __webpack_public_path__ + "static/img/9-1.e713e41.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/4/eng/9-1.png
// module id = ITCx
// module chunks = 0